/** @jsxImportSource @emotion/react */
import { Box, css, Slider, SliderProps, useTheme } from '@mui/material'
import { prioritySliderContainer } from './PrioritySlider.styles'

export const PrioritySlider = ({ ...props }: SliderProps) => {
  const theme = useTheme()
  return (
    <Box css={prioritySliderContainer()}>
      <p>Lower</p>
      <Slider
        {...props}
        marks={[
          { value: 0, label: '0' },
          { value: 1, label: '1' },
          { value: 2, label: '2' },
          { value: 3, label: '3' },
          { value: 4, label: '4' },
          { value: 5, label: '5' },
        ]}
        min={0}
        max={5}
        css={css`
          color: ${theme.palette.secondary[700]};
        `}
      />
      <p>Higher</p>
    </Box>
  )
}
